import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
// import { connect } from 'react-redux'
import { FormErrors } from "./FormErrors";
import "./styles.css";
import store from "../../config/store";
import { login } from "../../actions/user";

const { dispatch } = store;

class FormLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "password",
      email: "",
      formErrors: { email: "", password: "", validation: "" },
      emailValid: false,
      formValid: false
    };
    this.showHide = this.showHide.bind(this);
  }

  submitForm(e) {
    e.preventDefault();
    const { email, password, formErrors } = this.state;
    if (email.length === 0) {
      alert("Моля, попълнете всички полета");
    } else {
      dispatch(
        login({
          email,
          password
        })
      ).then(result => {
        if (result.success) {
          this.props.history.push("/journal");
        } else {
          this.setState({
            formErrors: {
              ...this.state.formErrors,
              validation: result.message
            }
          });
        }
      });
    }
  }

  handleUserInput = e => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  };

  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let emailValid = this.state.emailValid;

    switch (fieldName) {
      case "email":
        emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        fieldValidationErrors.email = emailValid ? "" : " is invalid";
        break;
      default:
        break;
    }

    this.setState(
      {
        formErrors: fieldValidationErrors,
        emailValid: emailValid
      },
      this.validateForm
    );
  }

  validateForm() {
    this.setState({ formValid: this.state.emailValid });
  }

  errorClass(error) {
    return error.length === 0 ? "" : "has-error";
  }

  showHide(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      type: this.state.type === "password" ? "input" : "password"
    });
  }

  render() {
    return (
      <div className="form-login">
        <form onSubmit={this.submitForm.bind(this)}>
          <FormErrors
            formErrors={this.state.formErrors}
            classNam="formErrors"
          />

          <div className="form-row">
            <div
              className={`form-group ${this.errorClass(
                this.state.formErrors.email
              )}`}
            >
              <input
                type="email"
                placeholder="имейл"
                className="input"
                name="email"
                value={this.state.email}
                onChange={this.handleUserInput}
              />
            </div>
          </div>

          <div className="form-row form-row-pass">
            <input
              name="password"
              placeholder="парола"
              type={this.state.type}
              className="input"
              value={this.state.password}
              onChange={this.handleUserInput}
            />
            <div className="eye" onClick={this.showHide}>
              <span
                className={
                  this.state.type === "password"
                    ? "icon-eye-off"
                    : "icon-eye-on"
                }
              />
            </div>
          </div>

          <div className="form-row">
            <Link to="/password-forgotten" className="link-forgotten-password">
              Забравена парола
            </Link>
          </div>

          <div className="form-row-bttn">
            <input type="submit" value="Влез" className="bttn" />
          </div>
        </form>
      </div>
    );
  }
}

export default withRouter(FormLogin);



// WEBPACK FOOTER //
// ./src/components/FormLogin/FormLogin.js